// extracted by mini-css-extract-plugin
module.exports = {"empty":"cuadrilleros_empty__r_pbv","list":"cuadrilleros_list__25P_T","special":"cuadrilleros_special__2itDz","li":"cuadrilleros_li__3A2VJ","form":"cuadrilleros_form__2CI2C"};